import React, { useState, useEffect, useContext } from "react";
import DataTable from 'react-data-table-component';
import { IoCalendarOutline } from "react-icons/io5";
import { LuEye, LuTrash2, LuPencil } from "react-icons/lu";
import candidateApi from "../../services/candidateApi";
import { getPriorityName } from "../../utils/common"
import { AuthContext } from "../../context/AuthContext";
import { CandidateForm } from "../../components/candidateForm/candidateForm";
import { useNavigate } from "react-router-dom";
import { FunctionalityNames } from "../../enum/enum";
import { getPermissionRights } from "../../utils/common";
import { toast } from 'react-toastify';
import ownIcon from '../../assets/images/icon.png';



// export const ListView = ({handleEditClick }) => {
export const ListView = ({ selectedTab, searchText, setSearchText, reloadData, candidateBoardStatus, tagStatus }) => {
  const { rolePermissions } = useContext(AuthContext);
  const [candidateListPerm, setCandidateListPerm] = useState({});

  const [isPopupupVisible, setIsPopupupVisible] = useState(false);
  const [candidateList, setCandidateList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [totalPages, setTotalPage] = useState(10);
  // const [searchText, setSearchText] = useState("");  
  const [editingRowId, setEditingRowId] = useState();
  const { accountFilterValue, setAccountFilterValue } = useContext(AuthContext);
  const { departmentFilterValue, setDepartmentFilterValue } = useContext(AuthContext);
  const { countryFilterValue, setCountryFilterValue } = useContext(AuthContext);
  const { yearFilterValue, setYearFilterValue } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("ASC");
  const navigate = useNavigate();

  const [visibleRowId, setVisibleRowId] = useState(null);
  const moreOptionsRef = React.useRef(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);



  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (moreOptionsRef.current && !moreOptionsRef.current.contains(event.target)) {
        setVisibleRowId(null);
        setMenuPosition(null);
        // onToggleOuterClass(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleRow = (rowId, e) => {
    e.stopPropagation();

    if (visibleRowId === rowId) {
      setVisibleRowId(null);
      setMenuPosition(null);
      setMenuWidth(null);
      // onToggleOuterClass(false);

      return;
    }

    // Get the bounding rect of the more-holder container, assuming button is inside it
    const containerRect = e.currentTarget.parentElement.getBoundingClientRect();

    const windowHeight = window.innerHeight;

    const dropdownItems = candidateList.find(item => item.Id === rowId)?.candidateJob || [];
    const visibleOptionsCount = dropdownItems.length;
    const estimatedMenuHeight = visibleOptionsCount * 34;

    const spaceBelow = windowHeight - containerRect.bottom;
    const spaceAbove = containerRect.top;

    const shouldShowAbove = spaceBelow < estimatedMenuHeight && spaceAbove > estimatedMenuHeight;

    const top = shouldShowAbove
      ? containerRect.top - estimatedMenuHeight - 4
      : containerRect.bottom + 2;

    // Use container's left for horizontal positioning
    const left = containerRect.left;
    const width = containerRect.width;
    setMenuPosition({ top, left });
    setMenuWidth(width);
    setVisibleRowId(rowId);
    // onToggleOuterClass(true);

  };


  const columns = [
    {
      name: 'Name',
      width: "150px",
      selector: (row) => row ? `${row.firstName} ${row.lastName}` : '',
      sortable: true,
      id: "firstName", // Unique column ID for sorting
    },
    //  {
    //   name: 'Tag',
    //   width: "50px",
    //   // selector: (row) => row ? `${row.firstName} ${row.lastName}` : '',
    //    cell: (row) => (
    //     <div>
            // candidate tag start here 
          //  <span className="featured"><FaStar /></span>
          // <span className="featured blacklist"><MdBlockFlipped /></span> 
        //  <span className="featured own">
        //      <img 
        //       src={ownIcon}
        //       alt="Profile" 
        //     />
        //   </span> 
          // candidate tag ends here 
        // </div> 
      //  )
    
    // },

    {
      name: 'Current Title',
      width: "135px",
      selector: (row) => row.candidateTitle,
      sortable: true,
      id: "candidateTitle", // Unique column ID for sorting
    },
    {
      name: 'Contact Number',
      width: "145px",
      selector: (row) => row.mobile,
      sortable: false
    },
    {
      name: 'Email ID',
      width: "180px",
      selector: (row) => row.email
    },
    {
      name: 'Skills',
      width: "200px",
      selector: (row) => row.skills,
      cell: (row) =>
        row.skillName && row.skillName.length > 0 ? (
          <div
            className="skills-holder w-100"
            title={row.skillName.join(', ')}
          >
            {row.skillName.join(', ')}
          </div>
        ) : (
          <p className="mb-0">No skills available</p>
        ),
    },
    {
      name: 'Experience',
      width: "125px",
      selector: (row) => `${row.experienceInYears || 0}.${row.experienceInMonths || 0} Years`,
      sortable: true,
      id: "experienceInYears", // Unique column ID for sorting 
    },
    {
      name: 'Mapped To',
      cell: (row) => (
        <div className="d-flex position-relative more-holder">
          <div className="d-flex gap-2 align-items-center">
            <div className="main-list-item">
              {row.candidateJob[0]}
            </div>
            {row.candidateJob.length > 1 && (
              <button
                type="button"
                className="btn plain-btn-primary triger-btn"
                onClick={(e) => toggleRow(row.Id, e)}
                aria-haspopup="true"
                aria-expanded={visibleRowId === row.Id}
                aria-controls={`dropdown-menu-${row.Id}`}
              >
                +{row.candidateJob.length - 1}
              </button>
            )}
          </div>
          {visibleRowId !== null && menuPosition && (() => {
            // Find currently active dropdown items
            const dropdownItems = candidateList.find(item => item.Id === visibleRowId)?.candidateJob || [];
            const estimatedMenuHeight = dropdownItems.length * 34;

            return (
              <div
                ref={moreOptionsRef}
                className="more-option-holder"
                style={{
                  position: "fixed",
                  top: `${menuPosition.top}px`,
                  left: `${menuPosition.left}px`,
                  zIndex: 1000,
                  width: menuWidth,

                }}
              >
                {dropdownItems.map((job, index) => (
                  <div key={index} className="list-item" title={job}>
                    {job}
                  </div>
                ))}
              </div>
            );
          })()}


        </div>

      ),
    },
    {
      name: 'Status',
      width: '125px',
      //selector: (row) => row.candidateStatus, 
      cell: (row) => (
        <div className={row.activitystatus === "Rejected" ? "status red" : " status primary"}>
          {row.activitystatus}
        </div>
      ),
    },
    {
      name: "Action",
      width: "150px",
      sortable: false,
      button: true,
      right: true,
      cell: (row) => (
        <div className="gridIcons d-flex gap-2 justify-content-center pe-5" data-tag="allowRowEvents">
          {candidateListPerm?.edit === 1 && (
            <button
              type="button"
              className="btn plain-btn-primary view-btn secondary-color"
              title="Details"
              onClick={() => handleEditClick(row)}
            >
              <LuPencil />
            </button>
          )}
          {candidateListPerm?.view === 1 && (
            <button
              type="button"
              className="btn plain-btn-primary view-btn primary-color"
              title="Details"
              onClick={() => handleViewClick(row.id)}
            >
              <LuEye />
            </button>
          )}
          {/* {candidateListPerm?.delete === 1 && (
          <button
            type="button"
            className="btn plain-btn-primary reddish-color"
            title="Delete"
            onClick={() => onClickDelete(row)}
          >
            <LuTrash2 />
          </button>
          )} */}
        </div>
      ),
    }
  ];

  
  const onClickDelete = async (candidateData) => {
    const userConfirmed = window.confirm("Are you sure you want to delete this item?");
    if (userConfirmed) {
      const response = await candidateApi.deleteCandidate(candidateData.id);
      console.log(response);
      if (response?.ok) {
        fetchData(currentPage, searchText);
        toast.success("Candidate deleted successfully", {
          position: "top-right",
          autoClose: 2000,
        });
      }
      else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 2000,
        });
      }
    }

  };

  const fetchData = async (page,searchText, column, order) => {
    try {     
 
        let queryString = `?pageIndex=${page}&pageLimit=${rowsPerPage}`;
        if (searchText) {
          queryString += `&searchText=${encodeURIComponent(searchText)}`;
        }
        if (departmentFilterValue && departmentFilterValue>0) {
            queryString += `&departmentId=${departmentFilterValue}`;
        }
        if (accountFilterValue && accountFilterValue>0) {
            queryString += `&accountId=${accountFilterValue}`;
        }
        if (yearFilterValue && yearFilterValue>0) {
            queryString += `&year=${yearFilterValue}`;
        }
        if(countryFilterValue && countryFilterValue>0){
            queryString += `&country=${countryFilterValue}`;
        }   
        if(candidateBoardStatus && candidateBoardStatus > 0){
          queryString += `&boardId=${candidateBoardStatus}`;
      } 
        if (column && order) {
          queryString += `&sortColumn=${column}&sortOrder=${order}`;
        }
        if (tagStatus) {
          queryString += `&tagStatus=${tagStatus}`;
        }
        
       
        const response = await candidateApi.getAllCandidateDetails(queryString)            
        let candidateList = response?.data;
        // if(candidateStatus){
        //   candidateList = candidateList.filter((item) => item.candidateStatus === candidateStatus);
        // }
        console.log("Fetched Data:", candidateList);
        setCandidateList(candidateList);
        let totalRecordsCount=candidateList?.[0]?.totalRecords || 0
        setTotalRecords(totalRecordsCount);
        //alert(totalRecordsCount/rowsPerPage)
        setTotalPage(Math.ceil(totalRecordsCount/rowsPerPage));
        

      //console.log(totalPages)
    } catch (error) {
      console.error("Error fetching candidate data:", error);
      toast.error("Error fetching candidate data", {
        position: "top-right",
        autoClose: 2000,
      });
    }
  };
  useEffect(() => {
    // debugger;
    console.log('fetchdata called');
    fetchData(currentPage, searchText);
  }, [accountFilterValue, yearFilterValue, countryFilterValue, isPopupupVisible, selectedTab, searchText]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, searchText, sortColumn, sortOrder);
  };

  // Handle sorting
  const handleSort = (columnId) => {
    const order = sortColumn === columnId && sortOrder === "ASC" ? "DESC" : "ASC";
    setSortColumn(columnId);
    setSortOrder(order);
    fetchData(currentPage, searchText, columnId, order);
  };


  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to page 1 when rows per page changes
    fetchData(1, searchText); // Fetch data for the first page
  };
  const handleInputChange = (e) => {
    setSearchText(e.target.value);
    fetchData(currentPage, e.target.value);
  };

  const handleSearch = () => {
    console.log("Searching for:", searchText); // Replace with actual search logic
    fetchData(currentPage, searchText);
  };

  const handleEditClick = async (item) => {
    setEditingRowId(item.id);
    setIsPopupupVisible(true);
  };
  const showPopup = () => {
    setIsPopupupVisible(true);
  };

  const hidePopup = () => {
    setIsPopupupVisible(false);
    // fetchData(currentPage,searchText);
  };
  const handleViewClick = (id) => {
    navigate(`/candidate/candidate-details/${id}`);
  };
  useEffect(() => {
    fetchData(currentPage, searchText);
  }, [reloadData]);
  useEffect(() => {
    if (rolePermissions) {
      setCandidateListPerm(getPermissionRights(rolePermissions, FunctionalityNames.CANDIDATE));
    }
  }, [rolePermissions]);


  return (
    <div className="data-table-holder cand-list">
      <DataTable
        columns={columns}
        data={candidateList}
        pagination
        paginationServer
        paginationTotalRows={totalRecords}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange}
        progressPending={loading} // Show loader while fetching data
        sortServer // Enables backend sorting
        onSort={(column, sortDirection) =>
          handleSort(column.id) // Use column ID for sorting
        }
        noDataComponent={
          <div style={{ width: '100%', textAlign: 'center', padding: '30px' }}>
            No candidates found
          </div>
        }
      />
      {isPopupupVisible && <CandidateForm closePopup={hidePopup} candidateId={editingRowId} editMode={true}
        reloadData={fetchData} page={currentPage} />}



    </div>
  );
}

